import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RemindersKeys } from "web_myplann/Api/Reminders/RemindersKeys";
import {
	addReminderToListCache,
	refetchReminderListsOnConflict,
} from "web_myplann/Api/Reminders/remindersCacheUtils";
import {
	postPortfolioPortfolioIdRemindersV2,
	type ReminderResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";
import type { ReminderCreateFormModel } from "web_myplann/Reminders/Forms/reminderFormSchema";
import { mapReminderFormToCreateRequest } from "web_myplann/Reminders/Mappers/mapReminderToRequest";

type CreateReminderVariables = {
	portfolioId: number;
	model: ReminderCreateFormModel;
};

export const usePortfolioReminderCreateMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<ReminderResponseDTO, Error, CreateReminderVariables>({
		mutationFn: processResponse(
			({ portfolioId, model }: CreateReminderVariables) =>
				postPortfolioPortfolioIdRemindersV2(
					mapReminderFormToCreateRequest(model),
					portfolioId,
				),
		),
		onError: (error, { portfolioId }) => {
			refetchReminderListsOnConflict(
				queryClient,
				error,
				RemindersKeys.portfolioList(portfolioId),
			);
		},
		onSuccess: (reminder, { portfolioId }) => {
			addReminderToListCache(
				queryClient,
				RemindersKeys.portfolioList(portfolioId),
				reminder,
			);
		},
	});
};
